import React, { Component } from 'react';

import defaultStyles from './default.less';

interface Props extends React.HTMLProps<HTMLTextAreaElement> {
	isInvalid: boolean;
	autoFocus: boolean;
	styles: {
		default: string;
		invalid: string;
		clearButton: string;
		clearable: string;
	};
	onClear?(): void;
}

export class TextArea extends Component<Props> {
	static defaultProps = {
		isInvalid: false,
		autoFocus: false,
		styles: defaultStyles,
	};

	element = React.createRef<HTMLTextAreaElement>();

	componentDidMount() {
		if (this.props.autoFocus) {
			this.focus();
		}
	}

	render() {
		const { isInvalid, onClear, type, styles, ...props } = this.props;
		const className = `${onClear !== undefined ? styles.clearable : ''} ${isInvalid ? styles.invalid : styles.default}`;

		const { autoFocus, ...textareProps } = props;

		const input = <textarea className={className} ref={this.element} {...textareProps} />;

		return onClear !== undefined ? (
			<span style={{ position: 'relative' }}>
				{input}
				<div className={styles.clearButton} role='button' onClick={onClear}>
					×
				</div>
			</span>
		) : (
			input
		);
	}

	focus() {
		if (this.element.current !== null) {
			this.element.current.focus();
		}
	}

	selectAllText() {
		if (this.element.current !== null) {
			this.element.current.setSelectionRange(0, this.element.current.value.length);
		}
	}
}
